export default __webpack_public_path__ + "static/media/020_start.vp9.03006c6c.webm";